const theme = {
  mode: 'dark',
  primary: {
    main: '#00AEEF', // Яркий голубой, как у Telegram
  },
  secondary: {
    main: '#ffffffff', // Оранжевый, ассоциирующийся с криптовалютами
  },
  background: {
    default: '#121212',
    paper: '#1E1E1E',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#e3e3e3ff',
  },
};

export default theme;